import { ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";

const POWER_INSUFFICIENT_HANDLED_FLAG = "__powerInsufficientHandled__";
const POWER_INSUFFICIENT_KEYWORDS = ["积分不足", "企业积分不足", "影豆不足", "企业影豆不足"] as const;

type ErrorLike = Record<string, unknown>;

let powerInsufficientDialogOpened = false;

function pickErrorMessage(error: unknown): string {
    if (!error || typeof error !== "object") {
        return "";
    }
    const payload = error as ErrorLike;
    if (typeof payload.msg === "string") {
        return payload.msg;
    }
    if (typeof payload.message === "string") {
        return payload.message;
    }
    return "";
}

export function isPowerInsufficientMessage(message?: string | null): boolean {
    if (!message) {
        return false;
    }
    return POWER_INSUFFICIENT_KEYWORDS.some((keyword) => message.includes(keyword));
}

export function markPowerInsufficientHandled<T extends ErrorLike>(error: T): T & { [POWER_INSUFFICIENT_HANDLED_FLAG]: true } {
    return {
        ...error,
        [POWER_INSUFFICIENT_HANDLED_FLAG]: true,
    };
}

export function shouldSuppressPowerInsufficientError(error: unknown): boolean {
    if (!error || typeof error !== "object") {
        return false;
    }
    const payload = error as ErrorLike;
    if (payload[POWER_INSUFFICIENT_HANDLED_FLAG] === true) {
        return true;
    }
    return isPowerInsufficientMessage(pickErrorMessage(payload));
}

/** 影豆不足时提示并跳转到充值页 */
export async function showPowerInsufficientRechargeDialog(): Promise<void> {
    if (powerInsufficientDialogOpened) {
        return;
    }
    powerInsufficientDialogOpened = true;

    try {
        const router = useRouter();
        await ElMessageBox.alert("当前账户影豆不足，请先充值", "影豆不足", {
            confirmButtonText: "去充值",
            type: "warning",
        });
        router.push("/pricing");
    } finally {
        powerInsufficientDialogOpened = false;
    }
}
